import { LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { SERVICE_NAME as SYSTEM_SERVICE_NAME, SystemService, $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_INTERNATIONALIZATION_SERVICE_NAME, SystemInternationalizationService } from '../../../services/system'
import { SupplierService, SUPPLIER_SERVICE_NAME } from '../../../../app/services/supplier'
import { GridService, GRID_SERVICE_NAME } from '../../../services/grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'

import { SupplierDetailsDirectiveController } from './supplier-details.directive.controller'

//#region Asset Imports

import './supplier-details.scss'
import * as TEMPLATE from './supplier-details.tpl.html'

//#endregion

// Setup

export class SupplierDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        'logger',
        $TIMEOUT_SERVICE_NAME,
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        SUPPLIER_SERVICE_NAME,
        GRID_SERVICE_NAME,
        SYSTEM_INTERNATIONALIZATION_SERVICE_NAME,
        (
            $scope,
            $q: ng.IQService,
            logger: LoggerService,
            $timeout: ng.ITimeoutService,
            localDictionary: LocalDictionaryFactory,
            userSession: UserSessionService,
            systemService: SystemService,
            supplierService: SupplierService,
            gridService: GridService,
            systemInternationalizationService: SystemInternationalizationService
        ) => new SupplierDetailsDirectiveController(
            $scope,
            $q,
            logger,
            $timeout,
            localDictionary,
            userSession,
            systemService,
            supplierService,
            gridService,
            systemInternationalizationService,
            SupplierService.REFERENCE_TYPE,
            SupplierService.SIMAX_MODULE_NAME
        )]

    template = TEMPLATE

    // Setup End
}